import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi } from '@shared/api/rest';
import type { TransferReasonsResponse } from '@shared/api/rest/transferRequests';
import { ApiUtils } from '@shared/utils';
import { IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getTransferReasonsEffect = createEffect((params: IQueryParams) => TransferRequestsApi.getTransferReasons(params.signal));
const clearEvent = createEvent();

const $dataStore = createStore<TransferReasonsResponse[]>([])
  .on(getTransferReasonsEffect.done, (current, values) => values.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransferReasonsEffect.pending, (_, data) => data)
  .on(getTransferReasonsEffect.fail, () => false)
  .on(getTransferReasonsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransferReasonsEffect, () => null)
  .on(getTransferReasonsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransferReasonsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferReasonsStore = {
  events: {
    getTransferReasons: ApiUtils.wrapperApi(getTransferReasonsEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
